module.exports = __webpack_public_path__ + "71792de5ff68337e587e5b6164531932.MP3";